module.exports = "https://static.wmbcdn.com/uniweb/images/8f5e8706300aec3dc4ab2dafd1b37dd1.svg";